/* kōjō — global.js */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {

    /* ---- Accordions ---- */
    document.querySelectorAll('[data-accordion]').forEach(function (group) {
      group.querySelectorAll('[data-acc-head]').forEach(function (head) {
        head.addEventListener('click', function () {
          var item = head.closest('.accordion__item, .faq__item');
          if (!item) return;
          var isOpen = item.classList.contains('is-open');
          group.querySelectorAll('.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var s = o.querySelector('.sign'); if (s) s.textContent = '+';
          });
          if (!isOpen) {
            item.classList.add('is-open');
            var s = item.querySelector('.sign'); if (s) s.textContent = '–';
          }
        });
      });
    });

    /* ---- Variant selection ---- */
    document.querySelectorAll('[data-variants]').forEach(function (wrap) {
      var priceEl = document.querySelector('[data-price]');
      var nameEl  = document.querySelector('[data-variant-name]');
      wrap.querySelectorAll('input[name="id"]').forEach(function (input) {
        input.addEventListener('change', function () {
          wrap.querySelectorAll('[data-variant-card]').forEach(function (c) { c.classList.remove('is-selected'); });
          var card = input.closest('[data-variant-card]');
          if (card) card.classList.add('is-selected');
          if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;
          if (nameEl  && input.dataset.name)  nameEl.textContent  = input.dataset.name;
        });
      });
    });

    /* ---- Gallery thumbnails ---- */
    document.querySelectorAll('.gallery').forEach(function (g) {
      var main = g.querySelector('.gallery__main img');
      g.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          g.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          if (main && t.dataset.src) main.src = t.dataset.src;
        });
      });
    });

    /* ---- Deal card savings label ---- */
    document.querySelectorAll('.qty-card--deal').forEach(function (card) {
      var perk = card.dataset.perk || '';
      var match = perk.match(/(\d+)/);
      if (!match) return;
      var raw = parseInt(match[1], 10);
      var rounded = Math.round(raw / 5) * 5 || raw;
      var inner = card.querySelector('.qty-card__inner');
      if (!inner) return;
      var save = document.createElement('span');
      save.className = 'qty-card__save';
      save.textContent = 'Du sparst ' + rounded + ' €';
      inner.appendChild(save);
    });

    /* ---- Per-gram price update (30 g pro Dose) ---- */
    /*
     * Only runs on pages where the qty-grid has radio inputs (= multi-variant products).
     * Bundles/Sets use qty_mode_number:true (stepper) => no radios => IIFE exits immediately.
     * Accessories with 'Default Title' => hasDoseVariant = false => IIFE exits.
     * Matcha dose products (1 Dose / 2 Dosen / 3 Dosen) => hasDoseVariant = true => shows per-gram.
     */
    (function () {
      var allRadios = Array.from(document.querySelectorAll('.qty-grid input[name="id"]'));
      if (!allRadios.length) return;

      var hasDoseVariant = allRadios.some(function (r) {
        var card = r.closest('[data-variant-card]');
        var nameEl = card && card.querySelector('.qty-card__name');
        return nameEl && /\d+\s*(Dose|Dosen)/i.test(nameEl.textContent);
      });
      if (!hasDoseVariant) return;

      var GRAMS_PER_DOSE = 30;

      function parseMoney(str) {
        return parseFloat((str || '').replace(/[^\d,]/g, '').replace(',', '.')) || 0;
      }

      function getDoses(radio) {
        var card = radio.closest('[data-variant-card]');
        var nameEl = card && card.querySelector('.qty-card__name');
        var title = nameEl ? nameEl.textContent.trim() : '1';
        var m = title.match(/^(\d+)/);
        return m ? parseInt(m[1], 10) : 1;
      }

      var pgEl = document.querySelector('.product__unit-price, .product__per-gram');
      if (!pgEl) {
        var wrap = document.querySelector('.product__price-display');
        if (!wrap) return;
        pgEl = document.createElement('span');
        pgEl.className = 'product__per-gram';
        wrap.appendChild(pgEl);
      }

      var basePPG = parseMoney(allRadios[0].dataset.price) / GRAMS_PER_DOSE;

      function update(radio) {
        var price = parseMoney(radio.dataset.price);
        var doses = getDoses(radio);
        var ppg   = price / (doses * GRAMS_PER_DOSE);
        pgEl.textContent = ppg.toFixed(2).replace('.', ',') + ' €/g';
        if (doses > 1 && ppg < basePPG - 0.005) {
          pgEl.style.color      = '#c0392b';
          pgEl.style.fontWeight = '700';
          pgEl.style.fontSize   = '14px';
        } else {
          pgEl.style.color      = '';
          pgEl.style.fontWeight = '';
          pgEl.style.fontSize   = '';
        }
      }

      var checked = allRadios.find(function (r) { return r.checked; });
      if (checked) update(checked);

      allRadios.forEach(function (radio) {
        radio.addEventListener('change', function () { update(radio); });
      });
    })();

  });
})();
